import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import createApiClient from '../api/ApiClient';

const ApiClientContext = createContext({
  apiUrls: null,
  updateApiUrls: () => {},
});

export const ApiClientProvider = ({ children }) => {
  const [apiUrls, setApiUrls] = useState({
    mobileApiUrl: null,
    accountMgtApiUrl: null
  });

  // Memoized update function
  const updateApiUrls = useCallback(async () => {
  //   const urls = await createApiClient(); // This will check localStorage
  //   setApiUrls(urls);
  //   return urls;
  // }, []);
   try {
      const urls = await createApiClient(); 
      setApiUrls(urls);
      return urls;
    } catch (error) {
      console.error('Failed to update API URLs:', error);
      throw error;
    } 
  }, []);

  // Initial load
  useEffect(() => {
    updateApiUrls();
  }, [updateApiUrls]);


  // Skip rendering until we have URLs
  if (!apiUrls.mobileApiUrl || !apiUrls.accountMgtApiUrl) return null;

  return (
    <ApiClientContext.Provider value={{ apiUrls, updateApiUrls }}>
      {children}
    </ApiClientContext.Provider>
  );
};

export const useApiClient = () => {
  const context = useContext(ApiClientContext);
  if (!context) {
    throw new Error('useApiClient must be used within ApiClientProvider');
  }
  return context;
};